// @flow

import React from "react";
import classNames from "classnames";
import ReactSelect from "react-select";
import "./select.scss";

export type SelectItem = $Exact<{ value: number | string, label: string }>;

const Select = (props: ReactSelect.propTypes) => (
  <div className={classNames("Select", props.className)}>
    <ReactSelect
      classNamePrefix="Select"
      backspaceRemovesValue={false}
      {...props}
      isDisabled={props.readOnly}
    />
  </div>
);

export default Select;
